export const urls = {
    baseUrl: `${process.env.REACT_APP_BASEURL}/`,
    customerInfo: 'submit-customer-info',
    findCustomer: 'find-user',
    generateBlankForm: 'generate-blank-form',
};